import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { TaskType } from 'api/tasks';
import { logger } from 'services';
import { updateTaskInProjectTemplate } from '../../actions';
import { selectTemplateTask } from '../../selectors';
import { updateProjectTemplateTask } from '../../slices';
function* updateTaskInTemplateSaga(action) {
    try {
        const { payload: { taskId, payload } } = action;
        const task = yield select(selectTemplateTask(taskId));
        const newTask = !task.taskName;
        try {
            var _payload_fields, _task_fields;
            const currentFields = (task === null || task === void 0 ? void 0 : task.fields) && (task === null || task === void 0 ? void 0 : task.fields.length) > 0 ? payload.fields && ((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.length) > 0 ? task === null || task === void 0 ? void 0 : (_task_fields = task.fields) === null || _task_fields === void 0 ? void 0 : _task_fields.filter((f)=>{
                var _payload_fields;
                return !((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.map((x)=>x.fieldId).includes(f.fieldId));
            }) : task.fields : [];
            yield put(updateProjectTemplateTask({
                task: {
                    ...task,
                    ...payload,
                    fields: (payload === null || payload === void 0 ? void 0 : payload.fields) && (payload === null || payload === void 0 ? void 0 : payload.fields.length) > 0 ? [
                        ...currentFields,
                        ...payload.fields
                    ] : currentFields,
                    ...{
                        isCsatEnabled: payload.isCsatEnabled === undefined ? payload.type === TaskType.Milestone ? true : payload.type === TaskType.Task ? false : task.isCsatEnabled : payload.isCsatEnabled
                    }
                },
                updatePrivacyOfChildren: payload.private != null,
                isNew: newTask
            }));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (err) {
            yield put(updateProjectTemplateTask({
                task: {
                    ...task,
                    ...payload,
                    ...{
                        isCsatEnabled: payload.isCsatEnabled === undefined ? payload.type === TaskType.Milestone ? true : payload.type === TaskType.Task ? false : task.isCsatEnabled : payload.isCsatEnabled
                    }
                },
                updatePrivacyOfChildren: payload.private != null,
                isNew: newTask
            }));
        }
    /**
     * Commenting out old date shift logic code
     * TODO: to be removed after thorough code walk through.
     */ // if (payload.duration || payload.startDay) {
    //   yield put(updateProjectTemplateStartdayDuration({ taskId }));
    // }
    } catch (error) {
        logger.error('updateProjectTemplateTask failed', {
            error
        });
        message.error('There was an error updating the task');
    }
}
export function* watchUpdateTaskInProjectTemplateSaga() {
    yield takeLatest(updateTaskInProjectTemplate.type, updateTaskInTemplateSaga);
}
